var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3a1 1 0 00-1-1H1a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V3zM3.581 4.186A1 1 0 002.42 5.814l7 5a1 1 0 001.162 0l7-5a1 1 0 10-1.162-1.628L10 8.771 3.581 4.186z",
    fill: "#1C1D1F"
  })));
}

export default SvgIbEmailIcon;